import React, { useContext, useEffect, useMemo, useState } from "react";
import InterventionPrescription from "./InterventionPrescription";
import PrescriptionTest from "./PrescriptionTest";
import InterventionTrayaPrescription from "./InterventionTrayaPrescription";
import SoftBadge from "modules/common/SoftBadge";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button } from "react-bootstrap";
import { useCustomerMedicine, useInterventionPrescription} from "./store";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrescriptionTemplate from "modules/my_tickets/PrescriptionTemplate";
import { useProductMapping, useRootCauseData, useTicketHistory } from "../actionables/store";
import { useSetTag } from "modules/nextcall/store";
import secureLocalStorage from "react-secure-storage";
import { CLINIC_DOCTOR_FLAG, currentUser } from "modules/utilities/utility";
import _, { groupBy } from "lodash";
import { useClinicStore } from "modules/clinic-management/store";
import { latestTicketByCategory } from "functionCall";
import { get, map } from "lodash";
import moment from "moment";
import { prescriptionContext } from "./MedicineContext";

function MiddleWarePrescription({ caseId, setPrescriptionChecked, setPrescFileName, callType="", syntheticId=null, gender=null }) {
  const assignedDoctor = secureLocalStorage.getItem("first_name");
  const { addInterventionPrescription, prescription } =
    useInterventionPrescription();
  const { ticketData, fetchTicketHistory } = useTicketHistory();
  const { id } = useParams();
  const {
    prescriptionStore,
    setPrescriptionStore,
    medicine,
    setMedicine,
    prescriptionStoreTraya,
    setPrescriptionStoreTraya,
    medicineTraya,
    setMedicineTraya,
    prescriptionStoreTest,
    setPrescriptionStoreTest,
    medicineTest,
    setMedicineTest,
    clearPrescriptionStore
  } = useContext(prescriptionContext);
  const [customPres, setCustomPres] = useState(false);
  const [updateRes, setUpdateRes] = useState(false);
  const [monthSelection, setMonthSelection] = useState(null);
  const { setTagToCase } = useSetTag();
  const clinicDoctors = 	['clinic_doctor'];
  const { productsData, fetchProducts } = useProductMapping();
  const {clinicWritePrescription} = useClinicStore();
  const {rootCauseData, fetchRootCauseData} = useRootCauseData()

  function sortData(responses) {
    const data = responses
      .sort((responseA, responseB) => {
        return new Date(responseA.created_at) - new Date(responseB.created_at);
      })
      .reduce((acc, response) => {
        const synId = response.synthetic_id;
        acc[synId] = acc[synId] || [];
        acc[synId].push({
          displayDate: moment(response.updated_at).format(
            "MMM Do YYYY, h:mm a"
          ),
          ...response,
        });
        return acc;
      }, {});

    const sortedData = Object.values(data).reduce((acc, entry) => {
      const date = entry[0].displayDate;
      acc[date] = entry;
      return acc;
    }, {});
    return sortedData;
  }

  const syntheticData = sortData(syntheticId?.responses || []);
  const keys = Object.keys(syntheticData || {});
  const latestKey = keys?.[keys?.length - 1];
  const latestEntryArray = syntheticData?.[latestKey] || [];
  const latestSyntheticId = latestEntryArray?.[latestEntryArray?.length - 1]?.synthetic_id;
  

  const handleClose = () => {
    setTimeout(() => {
      clearPrescriptionStore();
    }, [2000]);
    if (setPrescriptionChecked) setPrescriptionChecked((prev) => !prev);
  };

  const monthSelectedData = () =>{
    let month = 0;
    if(monthSelection == "1 Month"){
      month = 1;
    } else if (monthSelection == "3 Month"){
      month = 3;
    } else if (monthSelection == "5 Month"){
      month = 5;
    }
    return month;
  }

  const handleSubmit = () => {
    if(clinicDoctors.includes(currentUser)){
      const medicineData = _.groupBy(productsData, product => product.medicine.display_name);
      const monthData = monthSelectedData();
      const newPrescriptionData = _.map(prescriptionStoreTraya, (item) => {
        const productDetail = medicineData[item.prescription][0];
        return {
          ...item,
          product_id: productDetail.product_principal_id,
          product_price: productDetail.product_price,
          single_images: productDetail.single_images,
          medicine_type: productDetail.medicine.type,
          mobile_image_path: productDetail.mobile_image_path,
          sku_hinglish_image: productDetail.sku_hinglish_image,
          sku_styled_image: productDetail.sku_styled_image,
          web_male_mobile: productDetail.web_male_mobile,
          web_mobile_screen_images: productDetail.web_mobile_screen_images,
          cart_cdn_images: productDetail.cart_cdn_images
        };
      });
      const prescriptionData = {
        case_id: caseId,
        month:monthData,
        prescription: [...newPrescriptionData, ...prescriptionStore, ...prescriptionStoreTest]
      };
      clinicWritePrescription(prescriptionData, toast, handleClose);
    }else{
      const allPrescription = [
        ...prescriptionStore,
        ...prescriptionStoreTraya,
        ...prescriptionStoreTest,
      ];
      const oralMinoxCheck = prescriptionStoreTraya.filter((item)=>item.prescription=='Minoxidil Tablet 3X10');
      if(oralMinoxCheck.length){
        setTagToCase(id, 'e0a1c70b-8efc-4da3-8b6b-289232c069e5');//prod
        // setTagToCase(id, '080fd2a9-f411-4b08-8cb7-fb70f95ab35d');//dev
      }
      addInterventionPrescription(caseId, allPrescription, toast, handleClose);
    }
    setCustomPres(true);
    setUpdateRes(true);
  };


  useEffect(() => {
    if(clinicDoctors.includes(currentUser)){
      fetchRootCauseData(latestSyntheticId, gender, true)
    }
    fetchTicketHistory(id);
    _.isEmpty(productsData) && fetchProducts();
  }, [id, latestSyntheticId]);

  const allopathyProduct = useMemo(() => {
    return productsData
      ?.filter(
        (item) => item?.medicine?.type === "allopathy" || CLINIC_DOCTOR_FLAG
      )
      .map((item) => {
        return {
          label: item?.medicine?.display_name,
          value: item?.medicine_id,
          comment: item?.medicine?.description,
          dosage: item?.medicine?.dosage,
        };
      });
  }, [productsData]);

  const mappedComment = useMemo(() => {
    return groupBy(allopathyProduct, "label");
  }, [allopathyProduct]);

  useEffect(()=>{
    if(clinicDoctors.includes(currentUser) && monthSelection){
      let resultData = get(rootCauseData, "bulk_product_ids", []);
      let countData;
      if(monthSelection == "1 Month"){
        countData ="itemCount";
      } else if (monthSelection == "3 Month"){
        countData = "_3MonthsItemCount"
      } else if (monthSelection == "5 Month"){
        countData = "_5MonthsItemCount"
      }
      const productMap = map(resultData, (item) => {
        return {
          prescription: item?.name,
          dosage: get(
            mappedComment,
            `[${item?.name}][0].dosage`,
            ""
          ),
          comment: get(
            mappedComment,
            `[${item?.name}][0].comment`,
            ""
          ),
          quantity: Number(item[countData]),
        };
      });
      setPrescriptionStoreTraya(productMap);
    }
  }, [rootCauseData, monthSelection]);

  let currentAssignedTicket = ticketData.filter((eachticket) => {
    return (
      eachticket.status === "Pending" &&
      ["medical_escalations", "customer_complaints"].includes(eachticket.category) &&
      eachticket.current_assignment.user_id === secureLocalStorage.getItem("id")
    );    
  });
  currentAssignedTicket.reverse();
  return (
    <div className="d-flex flex-column gap-2">
      {_.size(prescription) > 0 && customPres && updateRes && _.get(prescription, '[0].case_id', "")  == caseId && (
        <PrescriptionTemplate
          data={prescription}
          ticket={currentAssignedTicket} //ticket data
          doctor={assignedDoctor}
          setPrescFileName={setPrescFileName}
          isMiddelwarePresc={true}
        />
      )}
      <CardDiv
        title={
          <div className="m-n2">
            <SoftBadge bg="info" className="me-2 border-bottom">
              <div className="fs-1">Traya Internal Prescription</div>
            </SoftBadge>
          </div>
        }
        component={
          <div className="m-n2">
            <InterventionTrayaPrescription
              prescriptionStoreTraya={prescriptionStoreTraya}
              setPrescriptionStoreTraya={setPrescriptionStoreTraya}
              medicineTraya={medicineTraya}
              setMedicineTraya={setMedicineTraya}
              setMonthSelection={setMonthSelection}
              allopathyProduct={allopathyProduct}
              mappedComment={mappedComment}
            />
          </div>
        }
      />
      <CardDiv
        title={
          <div className="m-n2">
            <SoftBadge bg="info" className="me-2 border-bottom">
              <div className="fs-1">External Prescription</div>
            </SoftBadge>
          </div>
        }
        component={
          <div className="m-n2">
            <InterventionPrescription
              caseId={caseId}
              prescriptionStore={prescriptionStore}
              setPrescriptionStore={setPrescriptionStore}
              medicine={medicine}
              setMedicine={setMedicine}
            />
          </div>
        }
      />
      <CardDiv
        title={
          <div className="m-n2">
            <SoftBadge bg="info" className="me-2 border-bottom">
              <div className="fs-1">Medical Tests</div>
            </SoftBadge>
          </div>
        }
        component={
          <div className="m-n2">
            <PrescriptionTest
              prescriptionStoreTest={prescriptionStoreTest}
              setPrescriptionStoreTest={setPrescriptionStoreTest}
              medicineTest={medicineTest}
              setMedicineTest={setMedicineTest}
            />
          </div>
        }
      />
      <div className="text-end">
        <Button
          variant="info"
          className="w-25 text-center"
          onClick={handleSubmit}
          disabled={latestTicketByCategory(ticketData)?.status === "Closed" && !["Paid Call", "Offline Appointment"].includes(callType) ? true:false}
        >
          Save Prescription
        </Button>
      </div>
    </div>
  );
}

export default MiddleWarePrescription;
